import { SecLoanApplicationType, SecLoanPurposeType, SecLoansApplicationMetadata } from '@shared/sec-loans'

export const shouldSkipLoanBackgroundStep = (applicationMetadata: SecLoansApplicationMetadata): boolean => {
  return (
    applicationMetadata.applicationType === SecLoanApplicationType.PurchaseLoan ||
    applicationMetadata.applicationPurpose === SecLoanPurposeType.LoanTransferToSbank ||
    applicationMetadata.applicationPurpose === SecLoanPurposeType.Renovation
  )
}
